import { encrypt,decrypt } from "./cryptoData";

// 防抖函数
export const debounce = (func, delay) => {
  let timer;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func();
    }, delay);
  };
}

// 节流函数
export const throttle = (func, delay) => {
  let lastTime = 0;
  let params = null;
 
  return (...args) => {
    params = args;
    const now = Date.now();
    if (now - lastTime > delay) {
      func(...params);
      lastTime = now;
    }
  };
}

export const setStorage = (key, value) => {
  localStorage.setItem(key, encrypt(value));
};

export const getStorage = (key) => {
  return decrypt(localStorage.getItem(key));
};
